import { render, staticRenderFns } from "./AsdInsurance.vue?vue&type=template&id=d4daffd4&scoped=true"
import script from "./AsdInsurance.vue?vue&type=script&lang=js"
export * from "./AsdInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4daffd4",
  null
  
)

export default component.exports